/* eslint-disable @typescript-eslint/no-use-before-define */
import formatMonitor, { MediaFormat } from "./utils/formatMonitor";
import q from "qj/q";
import E from "qj/E";
import focusElement from "./utils/focusElement";
import throttle from "qj/throttle";

// ---------------------------------------------------------------------------

const htmlClass = document.documentElement.classList;

// Search
const initSearchToggler = () => {
  const qsearch = q(".qsearch");
  const searchTrigger = q<HTMLAnchorElement>(".ExtraMenu__item--search > a");
  const searchTriggerClose = q<HTMLAnchorElement>("a.Search__closelink");
  //const searchMobileTrigger = q('.searchlink > a');

  if (searchTrigger) {
    const toggleSearch = (e: MouseEvent) => {
      e.preventDefault();

      htmlClass.toggle("search-active");
      console.log(htmlClass);

      if (htmlClass.contains("search-active")) {
        qsearch?.removeAttribute("aria-hidden");
        setTimeout(function () {
          const inpt = document.getElementById("searchInput");
          if (inpt) {
            focusElement(inpt);
          }
        }, 50);
      } else {
        qsearch?.setAttribute("aria-hidden", "true");
      }
    };
    searchTrigger.addEventListener("click", toggleSearch);
    searchTriggerClose?.addEventListener("click", toggleSearch);
  }

  // const skipLinkHandler = (e: MouseEvent) => {
  //   e.preventDefault();
  //   if (isActive) {
  //     isOpen ? closeMenu() : openMenu();
  //   }
  // };
  // searchTrigger.on("click.trigger", (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   if ($html.is(".mnav-mega-active")) {
  //     _forceCloseMainNav($(".mnav"));
  //   }
  //   $html.toggleClass("search-active");
  //   if ($html.is(".search-active")) {
  //     $qsearch.removeAttr("aria-hidden");
  //     setTimeout(function () {
  //       $qsearch.find("input.searchform__field").focusHere();
  //     }, 50);
  //   } else {
  //     $qsearch.attr("aria-hidden", "true");
  //   }
  // });
};
initSearchToggler();
